import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface SkBarProps {
  width?: string;
  height?: string;
  /** Border radius CSS value (e.g. "9999px", "6px"). Defaults to a 4px round. */
  radius?: string;
  className?: string;
}

/** Rectangular bar — text lines, progress bars. */
export function SkBar({ width = '100%', height = '0.875rem', radius, className }: SkBarProps) {
  return (
    <Skeleton
      style={{ width, height, ...(radius ? { borderRadius: radius } : null) }}
      className={cn(!radius && 'rounded', className)}
    />
  );
}

interface SkCircleProps {
  size?: string;
  /** Override the circle into a rounded square (icon-tile silhouettes). */
  radius?: string;
  className?: string;
}

/** Circle — avatar and icon placeholders. */
export function SkCircle({ size = '2.5rem', radius, className }: SkCircleProps) {
  return (
    <Skeleton
      style={{ width: size, height: size, ...(radius ? { borderRadius: radius } : null) }}
      className={cn('shrink-0', !radius && 'rounded-full', className)}
    />
  );
}

interface SkChipProps {
  width?: string;
  height?: string;
  className?: string;
}

/** Pill chip — badge and count chip placeholders. */
export function SkChip({ width = '3.5rem', height = '1.25rem', className }: SkChipProps) {
  return <Skeleton style={{ width, height }} className={cn('shrink-0 rounded-full', className)} />;
}

interface SkBtnProps {
  width?: string;
  height?: string;
  className?: string;
}

/** Button placeholder. */
export function SkBtn({ width = '5rem', height = '2rem', className }: SkBtnProps) {
  return <Skeleton style={{ width, height }} className={cn('rounded-[11px]', className)} />;
}
